module.exports = __webpack_public_path__ + "img/microsoftteams-image_32.0017faaf.png";